// Central API Configuration
// This is the SINGLE SOURCE OF TRUTH for all API base URLs

// Determine environment
const isProduction = process.env.NODE_ENV === 'production';

// V1 APIs: Always use production URL
export const API_V1_BASE_URL = 'https://api.littlebookcompany.net/v1';

// V2 APIs: Use localhost for now (can be changed later)
export const API_V2_BASE_URL = 'https://littlebookcompany.net/v2';

// Base URL (for reference)
const API_BASE_URL = isProduction
    ? 'https://api.littlebookcompany.net'
    : 'https://littlebookcompany.net';

// Helper function to get full V1 API URL
export const getV1ApiUrl = (endpoint) => {
    // Remove leading slash if present
    const cleanEndpoint = endpoint.startsWith('/') ? endpoint.substring(1) : endpoint;
    return `${API_V1_BASE_URL}/${cleanEndpoint}`;
};

// Helper function to get full V2 API URL
export const getV2ApiUrl = (endpoint) => {
    // Remove leading slash if present
    const cleanEndpoint = endpoint.startsWith('/') ? endpoint.substring(1) : endpoint;
    return `${API_V2_BASE_URL}/${cleanEndpoint}`;
};

// Download API URL (uses different port for file downloads)
export const DOWNLOAD_API_BASE_URL = isProduction
    ? 'https://littlebookcompany.net/v1'
    : 'https://littlebookcompany.net/v2';

// Helper function to get full Download API URL
export const getDownloadApiUrl = (endpoint) => {
    // Remove leading slash if present
    const cleanEndpoint = endpoint.startsWith('/') ? endpoint.substring(1) : endpoint;
    return `${DOWNLOAD_API_BASE_URL}/${cleanEndpoint}`;
};

// Payment Gateway URLs
export const PAYMENT_GATEWAY_BASE_URL = isProduction
    ? 'https://littlebookcompany.net'
    : 'https://littlebookcompany.net';

export const PAYMENT_POSTBACK_URL = `${PAYMENT_GATEWAY_BASE_URL}/statuseasypay`;
export const PAYMENT_CONFIRM_URL = `${PAYMENT_GATEWAY_BASE_URL}/confirmpayment`;
export const PAYMENT_RETURN_URL = `${PAYMENT_GATEWAY_BASE_URL}/`;

export default API_BASE_URL;
